import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
export default /*#__PURE__*/(function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(props, _ref) {
    var $f7, $, $f7router, $on, $update, usr, item, calendarDateTime, itemChange, updateForm, updateDateTime, saveItem, deleteItem, nativeCalendar;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            $f7 = _ref.$f7, $ = _ref.$, $f7router = _ref.$f7router, $on = _ref.$on, $update = _ref.$update;
            _context3.next = 3;
            return myApp.user();

          case 3:
            usr = _context3.sent;
            item = usr.data.calendar.find(function (e) {
              return e.id == props.id;
            }) || {};
            itemChange = false;
            console.log(usr.data.calendar);
            /**
             * Page event: pageInit
             * https://framework7.io/docs/router-component.html#component-page-events
             */

            $on('pageInit', function () {
              /*calendarDateTime = $f7.calendar.create({
                inputEl: '#tsISO',
                timePicker: true,
                dateFormat: {month: 'numeric', day: 'numeric', year: 'numeric', hour: 'numeric', minute: 'numeric'},
                value: [item.tsISO || new Date()],
                toolbarCloseText: 'Imposta',
                cssClass: 'color-theme-secondary',
                on: {
                  close() {
                    let a = this.getValue();
                    updateForm({target: {id: 'tsISO'}}, a[0].toISOString());
                  }
                }
              }); //*/
            });
            /**
             * Page event: pageBeforeIn
             * https://framework7.io/docs/router-component.html#component-page-events
             */

            $on('pageBeforeIn', function () {
              // imposta valore iniziale del select #type e #repeat
              $('#type').val(item.type || '');
              $('#repeat').val(item.repeat || 0);
              var d = item.datetime ? new Date(item.datetime) : new Date();
              $('#tsISO').val(myApp.localDateTimeInputFormat(d));
            });
            /**
             * Page event: pageAfterIn
             * https://framework7.io/docs/router-component.html#component-page-events
             */

            $on('pageAfterIn', function () {//if (!item.tsISO) calendarDateTime.open();
            });
            /**
             * FCM init
             * js/cordova-app.js -> messaging()
             * cordova-plugin-firebase-messaging
             * https://www.npmjs.com/package/cordova-plugin-firebase-messaging
             * 
             */

            if ($f7.device.cordova && !myApp.FCM) {
              myApp.cordova.messaging();
              myApp.FCM = true;
              cordova.plugins.firebase.messaging.setBadge(0);
            }
            /**
             * Aggiorna evento -> salva automaticamente
             * @param {type} ev
             * @param {type} value
             * @returns {undefined}
             */


            updateForm = function updateForm(ev, value) {
              itemChange = true;
              item[ev.target.id] = value || $(ev.target).val();
            };

            updateDateTime = function updateDateTime(evt) {
              var d = new Date($('#tsISO').val());
              item.tsISO = d.toISOString();
              item.datetime = d.toString();
            };
            /**
             * Salva evento di calendario
             * 
             * @param {type} ev
             * @returns {undefined}
             */


            saveItem = /*#__PURE__*/function () {
              var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ev) {
                var i;
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        if (itemChange && $f7.input.validate('#caption') && $f7.input.validate('#datetime')) {
                          _context.next = 2;
                          break;
                        }

                        return _context.abrupt("return");

                      case 2:
                        item.description = $('#description').val() || '';
                        /* // salva evento nel calendario nativo
                         let nativeId = await nativeCalendar(item);
                         item.nativeId = (nativeId + '') || (item.id + '');
                         // */

                        if (!item.id) {
                          // evento nuovo -> Imposta id ed aggiunge record in usr.data.calendar
                          item.id = Date.now();
                          item.nativeId = item.nativeId || item.id + '';
                          usr.data.calendar.push(item);
                        } else {
                          // evento esistente -> recupera dalla collezione ed imposta item
                          i = usr.data.calendar.findIndex(function (e) {
                            return e.id == item.id;
                          });
                          usr.data.calendar[i] = item;
                        }
                        /*
                         * https://github.com/katzer/cordova-plugin-local-notifications#readme
                         * cordova.plugins.notification.local.hasPermission(function (granted) { ... });
                         * cordova.plugins.notification.local.requestPermission(function (granted) { ... });
                         Events
                         The following events are supported: add, trigger, click, clear, cancel, update, clearall and cancelall.
                         cordova.plugins.notification.local.on(event, callback, scope);
                         
                         To unsubscribe from events:
                         cordova.plugins.notification.local.un(event, callback, scope);
                         
                         cordova.plugins.notification.local.schedule({
                         id: 15,
                         title: 'Happy Birthday!!!',
                         trigger: { every: { month: 10, day: 27, hour: 9, minute: 0 } }
                         });
                         cordova.plugins.notification.local.update({
                         id: 15,
                         text: [{ person: 'Irish', message: 'Bye bye' }]
                         });
                         */
                        // invia al server -> imposta collection usr.data.calendar


                        $f7.preloader.show();
                        _context.prev = 5;
                        _context.next = 8;
                        return myApp.server.putJSON('user/me/calendar', usr.data.calendar);

                      case 8:
                        usr.data.calendar = _context.sent;
                        _context.next = 11;
                        return myApp.user(usr);

                      case 11:
                        $f7.toastSuccess(lng.saved_ok);
                        itemChange = false;
                        _context.next = 18;
                        break;

                      case 15:
                        _context.prev = 15;
                        _context.t0 = _context["catch"](5);
                        // errore connesione al server -> mostra avviso
                        $f7.alertError(_context.t0);

                      case 18:
                        _context.prev = 18;
                        $f7.preloader.hide(); //$f7router.back();

                        return _context.finish(18);

                      case 21:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee, null, [[5, 15, 18, 21]]);
              }));

              return function saveItem(_x3) {
                return _ref3.apply(this, arguments);
              };
            }();
            /*
             * Elimina evento dal calendario
             */


            deleteItem = function deleteItem() {
              // mostra dialog
              $f7.dialog.confirm(lng.calendar_delete_message, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
                return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                  while (1) {
                    switch (_context2.prev = _context2.next) {
                      case 0:
                        if (item.id) {
                          _context2.next = 4;
                          break;
                        }

                        $f7router.back();
                        _context2.next = 21;
                        break;

                      case 4:
                        // Se l'evento esiste -> rimuove evento da user.data.calendar
                        usr.data.calendar = usr.data.calendar.filter(function (e) {
                          return e.id != item.id;
                        }); // -> Invia al server, salva user.data.calendar e torna indietro

                        $f7.preloader.show();
                        _context2.prev = 6;
                        _context2.next = 9;
                        return myApp.server.deleteJSON('user/me/calendar/' + item.id);

                      case 9:
                        _context2.next = 11;
                        return myApp.user(usr);

                      case 11:
                        // elimina evento dal calendario nativo
                        if ($f7.device.cordova && item.nativeId) {
                          window.plugins.calendar.deleteEventById(item.nativeId + '', false, function (success) {
                            return console.log(success, 'Calendar native deleteEventById success');
                          }, function (error) {
                            return consolelog(error, 'Calendar native deleteEventById error');
                          });
                        } // torna indietro (calendar_list)


                        $f7router.back();
                        _context2.next = 18;
                        break;

                      case 15:
                        _context2.prev = 15;
                        _context2.t0 = _context2["catch"](6);
                        // errore connesione al server -> mostra avviso
                        $f7.alertError(_context2.t0);

                      case 18:
                        _context2.prev = 18;
                        $f7.preloader.hide();
                        return _context2.finish(18);

                      case 21:
                      case "end":
                        return _context2.stop();
                    }
                  }
                }, _callee2, null, [[6, 15, 18, 21]]);
              })));
            };
            /**
             * Calendario nativo -> aggiunge / modifica evento
             * https://www.npmjs.com/package/cordova-plugin-calendar
             * 
             * @param {type} event
             * @returns {Promise} Alwais resolve() -> idEvent (iOS) | '' (Android) | false (on error)
             */


            nativeCalendar = function nativeCalendar(event) {
              // web debug
              if (!$f7.device.cordova) return Promise.resolve(false); // 1) elimina evento se esiste

              if (event.nativeId) {
                window.plugins.calendar.deleteEventById(event.nativeId, new Date(event.datetime), function (success) {
                  return console.log(success, 'Calendar native deleteEventById success');
                }, function (error) {
                  return consolelog(error, 'Calendar native deleteEventById error');
                });
              } // 2) crea evento con opzioni
              // create an event silently (on Android < 4 an interactive dialog is shown which doesn't use this options) with options:


              var calOptions = window.plugins.calendar.getCalendarOptions(); // grab the defaults

              calOptions.firstReminderMinutes = 60; // default is 60, pass in null for no reminder (alarm)

              calOptions.id = event.nativeId + ''; // Added these options in version 4.2.4:

              switch (event.repeat) {
                case '1':
                  calOptions.recurrence = 'daily';
                  break;

                case '2':
                  calOptions.recurrence = 'weekly';
                  break;

                case '3':
                  calOptions.recurrence = 'monthly';
                  break;
              }

              var d = new Date(event.tsISO);
              var d1 = new Date(d.getFullYear(), d.getMonth(), d.getDate(), d.getHours() + 1, d.getMinutes());
              return new Promise(function (resolve, reject) {
                window.plugins.calendar.createEventWithOptions(event.caption, '', event.description, d, d1, calOptions, function (success) {
                  return resolve(success);
                }, function (error) {
                  return reject(error);
                });
              });
            };

            return _context3.abrupt("return", function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="page" data-name="calendar-item">
    <div class="navbar">
      <div class="navbar-bg"></div>
      <div class="navbar-inner">
        <div class="left">
          <a href="#" class="link back">
            <i class="f7-icons ios-only">arrow_left</i>
            <i class="material-icons md-only">arrow_back</i>
          </a>
        </div>
        <div class="title sliding">Doctor Pass</div>
        <div class="right">
          <a href="#" @click=${deleteItem} class="link icon-only">
            <i class="icon f7-icons if-not-md">trash</i>
            <i class="icon material-icons if-md">delete</i>
          </a>
        </div>
      </div>
    </div>
    <div class="page-content bg-color-white hide-navbar-on-scroll">
      <h3 class="margin-left">${lng.calendar_item_title}</h3>
      <div class="list no-hairlines-md mt-0">
        <ul>
          <li>
            <div class="item-content item-input">
              <div class="item-inner">
                <div class="item-input-wrap">
                  <input type="datetime-local" placeholder="${lng.select_date_time}" required validate
                         @change=${updateDateTime}
                         id="tsISO" />
                </div>
              </div>
            </div>
          </li>

          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">Titolo *</div>
              <div class="item-input-wrap">
                <input @change=${updateForm} id="caption" type="text" placeholder="${lng.insert_title}" required validate value="${item.caption}" />
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>

          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.type}</div>
              <div class="item-input-wrap">
                <select id="type" @change=${updateForm}>
                  <option value=""></option>
                  <option value="visita">${lng.medical_examination}</option>
                  <option value="esame">${lng.laboratory_examination}</option>
                  <option value="medicina">${lng.medicine}</option>
                </select>
              </div>
            </div>
          </li>

          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.description}</div>
              <div class="item-input-wrap">
                <textarea @blur=${updateForm} id="description" placeholder="${lng.description}..." value="${item.description}"></textarea>
              </div>
            </div>
          </li>

          <li class="item-content item-input">
            <div class="item-inner">
              <div class="item-title item-label">${lng.repeat}</div>
              <div class="item-input-wrap">
                <select id="repeat" @change=${updateForm}>
                  <option value="0">${lng.not_repeat}</option>
                  <option value="1">${lng.everyday}</option>
                  <option value="2">${lng.weekly}</option>
                  <option value="3">${lng.monthly}</option>
                </select>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="block">
        <button @click=${saveItem} class="button button-large button-round button-fill color-secondary">
          <i class="f7-icons left">square_arrow_down</i>
          ${lng.save}
        </button>
      </div>

    </div>
  </div>
`
    }
    );

          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x, _x2) {
    return _ref2.apply(this, arguments);
  };
})();